export default __webpack_public_path__ + "static/media/tom.4c9f6e58.mp3";